/* ==========================================================================
   PREMIUM CUSTOM ANIMATIONS & INTERACTION RUNTIME
   ========================================================================== */

(function () {
  'use strict';

  // ── Apply dynamic stagger delays to stagger containers ──
  function initStaggerAnimations() {
    document.querySelectorAll('.reveal-stagger').forEach((container) => {
      const items = container.querySelectorAll('.reveal-stagger-item');
      const step = parseFloat(container.dataset.staggerStep) || 0.08;
      items.forEach((item, index) => {
        item.style.transitionDelay = `${index * step}s`;
      });
    });
  }

  // ── Scroll Reveal Observer ──
  function initScrollReveal() {
    const revealElements = document.querySelectorAll(
      '.reveal-on-scroll, .reveal-slide-left, .reveal-slide-right, .reveal-scale-up, .reveal-scale-down'
    );

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -8% 0px', // Trigger when element is 8% visible
      threshold: 0.08,
    };

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target;
          
          // If it's a stagger container, reveal all items inside it sequentially
          if (target.classList.contains('reveal-stagger')) {
            const items = target.querySelectorAll('.reveal-stagger-item');
            items.forEach((item) => {
              item.classList.add('is-revealed');
            });
            target.classList.add('is-revealed');
          } else {
            target.classList.add('is-revealed');
          }
          
          // Stop observing after entry reveal
          observer.unobserve(target);
        }
      });
    }, observerOptions);

    // Helper to observe elements properly
    function observeElement(el) {
      if (el.closest('.reveal-stagger') && el.classList.contains('reveal-stagger-item')) {
        return;
      }
      revealObserver.observe(el);
    }

    revealElements.forEach(observeElement);

    // Also observe stagger containers themselves
    document.querySelectorAll('.reveal-stagger').forEach((staggerContainer) => {
      revealObserver.observe(staggerContainer);
    });

    // Watch for dynamic DOM additions (e.g. AJAX-loaded sections)
    const dynamicObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          
          // Find all revealable elements inside the added node
          const newRevealables = node.querySelectorAll(
            '.reveal-on-scroll, .reveal-slide-left, .reveal-slide-right, .reveal-scale-up, .reveal-scale-down'
          );
          
          newRevealables.forEach(observeElement);
          
          if (node.matches('.reveal-on-scroll, .reveal-slide-left, .reveal-slide-right, .reveal-scale-up, .reveal-scale-down')) {
            observeElement(node);
          }
          
          // Watch for newly added stagger containers
          if (node.matches('.reveal-stagger')) {
            revealObserver.observe(node);
          }
          node.querySelectorAll('.reveal-stagger').forEach((stagger) => {
            revealObserver.observe(stagger);
          });
        });
      });
    });
    
    dynamicObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ── Tab Collections Mutation Observer ──
  // Re-staggers product grid cards whenever collections/tabs switch
  function initTabCollectionAnimations() {
    const panels = document.querySelectorAll('[role="tabpanel"]');
    if (!panels.length) return;

    const panelObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const panel = mutation.target;
        // Check if the display property is no longer none (becomes visible)
        if (panel.style.display !== 'none' && !panel.classList.contains('animating')) {
          panel.classList.add('animating');

          const staggerItems = panel.querySelectorAll('.reveal-stagger-item, .product-card');
          staggerItems.forEach((item, index) => {
            // Apply delay dynamically and force animation reset
            item.classList.remove('is-revealed');
            item.style.transitionDelay = `${index * 0.08}s`;
            // Trigger reflow
            void item.offsetWidth;
            item.classList.add('is-revealed');
          });

          // Debounce active flag to prevent duplicate runs
          setTimeout(() => {
            panel.classList.remove('animating');
          }, 400);
        }
      });
    });

    panels.forEach((panel) => {
      panelObserver.observe(panel, {
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    });
  }

  // ── Document Lifecycle Initializer ──
  function initAll() {
    initStaggerAnimations();
    initScrollReveal();
    initTabCollectionAnimations();
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Editor integration (re-run animations when sections load/unload in customizer)
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initAll, 100);
  });
})();
